<template>
  <div class="sommaire-view">
    <div class="header">
      <span class="app-title">impressions</span>
      <button class="about-btn" @click="$emit('go-about')">à propos</button>
    </div>

    <div class="recueils-grid">
      <div v-for="(recueil, ri) in recueils" :key="recueil.name" class="recueil-block">
        <div class="recueil-header" @click="$emit('go-recueil', ri)">
          <span class="recueil-name">{{ recueil.name }}</span>
          <span class="recueil-line"></span>
          <span class="recueil-year">{{ recueil.year }}</span>
        </div>

        <div
          v-for="(texte, ti) in recueil.texts"
          :key="texte.title"
          class="texte-row"
          @click="$emit('go-texte', ri, ti)"
        >
          <span class="texte-num">{{ pad2(ti) }}</span>
          <span class="texte-title">{{ texte.title }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { RecueilData } from '../types'

defineProps<{ recueils: RecueilData[] }>()

defineEmits<{
  'go-about': []
  'go-recueil': [ri: number]
  'go-texte': [ri: number, ti: number]
}>()

function pad2(i: number): string {
  return String(i + 1).padStart(2, '0')
}
</script>

<style scoped>
.sommaire-view {
  box-sizing: border-box;
  min-height: 100vh;
  background: #171B21;
  padding: 40px 30px 60px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.app-title {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 13px;
  letter-spacing: 0.3em;
  text-transform: uppercase;
  color: #F4F6F8;
}

.about-btn {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: 'IBM Plex Mono', monospace;
  font-size: 10px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #B6D2E8;
}

.about-btn:hover { color: #F4F6F8; }

.recueils-grid {
  margin-top: 44px;
  column-count: 1;
  column-gap: 56px;
}

.recueil-block {
  display: flex;
  flex-direction: column;
  gap: 10px;
  break-inside: avoid;
  padding-bottom: 34px;
}

.recueil-header {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.recueil-header:hover .recueil-name,
.recueil-header:hover .recueil-year {
  color: #F4F6F8;
}

.recueil-name {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 10px;
  letter-spacing: 0.22em;
  color: #A6B4C2;
  white-space: nowrap;
  transition: color 0.15s;
}

.recueil-line {
  flex: 1;
  height: 1px;
  background: #333B45;
}

.recueil-year {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 10px;
  color: #B6D2E8;
  transition: color 0.15s;
}

.texte-row {
  display: flex;
  gap: 12px;
  align-items: baseline;
  padding: 7px 0;
  cursor: pointer;
  transition: opacity 0.15s;
}

.texte-row:hover { opacity: 0.72; }

.texte-num {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 10px;
  color: #A6B4C2;
  width: 22px;
  flex: none;
}

.texte-title {
  font-family: 'EB Garamond', serif;
  font-size: 21px;
  color: #F4F6F8;
  flex: 1;
}

@media (min-width: 640px) {
  .sommaire-view { padding: 48px 56px 60px; }
  .recueils-grid { column-count: 2; }
}

@media (min-width: 1100px) {
  .sommaire-view { padding: 64px 72px 60px; }
  .recueils-grid { column-count: 3; }
}
</style>
